export const ReleaseStage = Object.freeze({
  ALPHA: 'Alpha',
  BETA: 'Beta',
  DEVELOPMENT: 'Development'
});

export const DeviceName = Object.freeze({
  WEB: 'web',
  WEBAPP: 'webapp'
});